<div class="data-protection">
    <app-new-header></app-new-header>

    <div class="content">
        <h1>DATA PROTECTION NOTICE<br><span class="effective-date">Effective Date: September 2023</span></h1>

        <h2>Introduction</h2>
        <p>This data protection notice outlines how <strong>HuiosPay</strong> collects, uses, and protects personal information. We are committed to ensuring that your privacy is protected, in compliance with the Nigeria Data Protection Regulation (NDPR) and other applicable data protection laws.</p>

        <h2>Data Collected</h2>
        <p>We may collect the following types of personal information.</p>
        <ol type="a">
            <li>Identity Information:<br>Includes your name, contact details, and identification documents.</li>
            <li>Financial Information:<br>Includes details related to financial transactions conducted on our platform.</li>
            <li>Device Information:<br>Includes information about the device you use to access our services.</li>
            <li>Usage Information:<br>Includes data about your interactions with our platform.</li>
            <li>Other information relevant to customer surveys or offers.</li>
        </ol>

        <h2>How We Collect Data</h2>
        <p>We collect personal information in the following ways:</p>
        <ul>
            <li>Directly from individuals when they provide information to us, and</li>
            <li>Automatically when individuals use our website or services (e.g., through cookies).</li>
        </ul>

        <h2>How We Use Your Personal Data</h2>
        <p>We use your personal data for purposes including but not limited to account management, service delivery, and compliance with legal obligations.</p>

        <h2>Purpose of Data Processing</h2>
        <p>We process personal information for the following purposes.</p>
        <ul>
            <li>Providing and improving our products and services.</li>
            <li>Responding to inquiries and providing customer support.</li>
            <li>Internal record keeping.</li>
            <li>Marketing and promotional activities with your consent.</li>
        </ul>

        <h2>Legal Basis for Processing</h2>
        <p>We do not sell, trade, or transfer personal information to external parties unless we have obtained consent or are required by law to do so. We process personal data based on legal grounds such as the necessity for the performance of a contract, and compliance with legal obligations.</p>

        <h2>Data Security Measures</h2>
        <p>We implement appropriate technical and organizational measures to ensure the security and confidentiality of your personal data.</p>

        <h2>Third Party Disclosures</h2>
        <p>We may share your personal data with third-party service providers for the purpose of providing and improving our services. For more information, please refer to our <a href="/privacy-policy">Privacy Policy</a>.</p>

        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
            <li>Request access to the personal information we hold about you.</li>
            <li>Correct any inaccuracies in your personal information.</li>
            <li>Withdraw consent from processing personal information (where applicable).</li>
            <li>Request the deletion of your personal information.</li>
        </ul>

        <h2>Cookies and Similar Technologies</h2>
        <p>We use cookies and similar technologies. For more information, please refer to our <a href="/cookies-policy">Cookies Policy</a>.</p>

        <h2>Data Retention</h2>
        <p>We retain your personal data for as long as necessary to fulfil the purposes outlined in this notice or as required by law.</p>

        <h2>Changes to this Notice</h2>
        <p>We may update this data protection notice from time to time. Please check this page for the latest version.</p>

        <h2>Compliance with NDPR</h2>
        <p>We adhere to the Nigeria Data Protection Regulation and other applicable data protection laws.</p>

        <h2>Contact Information</h2>
        <p>If you have any questions or concerns about our data protection services, please contact us at <a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a> or <a href="tel:+2348037086670">+234 (0) 8037086670</a> | <a href="tel:+2348096247247">(0) 8096247247</a>.</p>

        <p><strong>Date of last update:</strong> September 2023</p>
    </div>

    <app-new-footer></app-new-footer>
</div>
